import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class OccupationalTherapy extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Occupational Therapy</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Occupational Therapy</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Occupational Therapy</h2>

                      <p>
                        Occupational Therapy is a specialized therapeutic service that helps
                        children develop the physical, sensory, cognitive, and functional skills
                        required to participate successfully in everyday activities. These
                        activities include playing, learning, eating, dressing, writing,
                        social interaction, and self-care. Some children may experience
                        difficulties with movement, coordination, sensory processing,
                        attention, or daily living skills, which can affect their
                        independence and overall development. Occupational Therapy is
                        designed to address these challenges and help children reach
                        their highest level of functioning.
                      </p>

                      <h3 className="section-space--top--50">Our Therapy Approach</h3>

                      <p>
                        The therapy begins with a comprehensive assessment to understand each
                        child’s strengths, needs, and developmental goals. Based on this
                        assessment, an individualized intervention plan is created to support
                        skill development in a structured and engaging manner. Therapy sessions
                        incorporate purposeful activities that improve fine and gross motor
                        skills, hand-eye coordination, balance, posture, sensory integration,
                        visual perception, attention, emotional regulation, and self-care
                        abilities.
                      </p>
                      <p>
                        Our therapists use evidence-based practices, play-based activities,
                        sensory-rich experiences, and functional exercises to make therapy
                        enjoyable and meaningful. Every activity is carefully selected to
                        encourage participation, build confidence, and help children apply
                        newly learned skills in their daily routines. The program is
                        designed to support children in becoming more independent at home,
                        in school, and within their communities.
                      </p>
                      <p>
                        Occupational Therapy is beneficial for children with autism spectrum
                        disorder, ADHD, developmental delays, sensory processing difficulties,
                        cerebral palsy, Down syndrome, learning disabilities, and other
                        conditions that affect everyday functioning. We also work closely
                        with parents, caregivers, and educators to ensure that therapeutic
                        strategies are consistently reinforced across different environments,
                        promoting lasting progress and meaningful outcomes.
                      </p>

                      <h3 className="section-space--top--50">Conclusion</h3>
                      <p>
                        At Shakuntla Learn and Fly Foundation, we believe that every child
                        deserves the opportunity to participate confidently in everyday life.
                        Our Occupational Therapy program is dedicated to helping children develop
                        the essential skills needed for independence, learning, and social
                        participation. Through individualized intervention, compassionate
                        care, and family collaboration, we empower children to overcome
                        challenges, build confidence, and achieve their fullest potential,
                        enabling them to lead more independent and fulfilling lives.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default OccupationalTherapy;
